import type { PaginationState } from '@tanstack/react-table'
import type { DateRange } from 'react-day-picker'
import { useQuery } from 'react-query'

import { SubscriberAnalysisService } from '@/modules/tracking/new-subscriber-analysis/service'
import { handleError } from '@/utils/error'

export const useSpendingList = (
  dateRange: DateRange,
  creatorId: number,
  pagination: PaginationState,
  high: boolean,
  spendLimit: number,
  shouldRequest: boolean,
) => {
  const {
    data: spendingCustomerList,
    isFetching: isSubscribersAnalysisLoading,
  } = useQuery(
    [
      'spendingCustomerList',
      creatorId,
      dateRange,
      high,
      pagination.pageSize,
      pagination.pageIndex,
      shouldRequest,
      spendLimit,
    ],
    ({ signal }) => {
      if (!creatorId || !shouldRequest) {
        return null
      }

      return SubscriberAnalysisService.getSpendingListCustomer(
        creatorId,
        high,
        dateRange.from || new Date(),
        dateRange.to || new Date(),
        pagination.pageSize,
        pagination.pageIndex,
        spendLimit,
        signal,
      )
    },
    {
      onError: (error) => handleError(error, 'Failed to get spending list'),
    },
  )

  return {
    spendingList: spendingCustomerList,
    isFetching: isSubscribersAnalysisLoading,
  }
}
